<template>
	<figure
		:class="[sizeClass, { cropped: cropped }]"
		:style="`${cropped ? `background-image: url(${avatar})` : null}`"
	>
		<img :src="avatar" :alt="alt" />
	</figure>
</template>

<script>
export default {
	props: {
		image: {
			type: String,
			required: true
		},
		alt: {
			type: String,
			default: ""
		},
		size: {
			type: String,
			default: null
		},
		cropped: {
			type: Boolean,
			default: () => false
		}
	},
	computed: {
		sizeClass() {
			return ["image", this.size];
		},
		avatar() {
			return this.image || null;
		}
	}
};
</script>

<style lang="scss" scoped>
figure.image {
	margin: 0;
}

.cropped {
	width: 100%;
	height: 100%;
	background-position: 50% 50%;
	background-size: cover;
	img {
		visibility: hidden;
	}
}

.image.is-256x256 {
	height: 256px;
	width: 256px;
}
.image {
	text-align: left;
	&.is-16-high,
	&.is-24-high,
	&.is-32-high,
	&.is-48-high,
	&.is-64-high,
	&.is-96-high,
	&.is-128-high,
	&.is-158-high {
		width: auto;
		img {
			height: 100%;
			width: auto;
		}
	}
	&.is-16-high {
		height: 16px;
	}
	&.is-24-high {
		height: 24px;
	}
	&.is-32-high {
		height: 32px;
	}
	&.is-48-high {
		height: 48px;
	}
	&.is-64-high {
		height: 64px;
	}
	&.is-96-high {
		height: 96px;
	}
	&.is-128-high {
		height: 128px;
	}
	&.is-158-high {
		height: 158px;
	}
}
</style>
